(function () {
  'use strict';
  /* Rainbow finder cache refresh 2026-08-13T21:15+10:00 */
  if (window.__ryFinderLoaded) return;
  window.__ryFinderLoaded = true;

  if (window.location.pathname.replace(/\/+$/, '') === '/pages/compare-kids-yoga-trainings') {
    window.location.replace('/pages/find-my-training' + window.location.search + window.location.hash);
    return;
  }

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true);
    } catch (error) { return false; }
  }

  function emit(name, detail) {
    var payload = detail || {};
    try { window.dispatchEvent(new CustomEvent('rainbow:' + name, { detail: payload })); } catch (error) {}
    if (analyticsAllowed()) {
      if (window.RainbowAnalyticsPush) {
        window.RainbowAnalyticsPush(name, Object.assign({ analytics_consent: true }, payload));
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: name, analytics_consent: true }, payload));
      }
    }
  }

  function initFinder(root) {
    if (!root || root.dataset.ryFinderInitialised === 'true') return;
    root.dataset.ryFinderInitialised = 'true';
    var form = root.querySelector('[data-ry-finder-form]');
    var result = root.querySelector('[data-ry-finder-result]');
    var cards = root.querySelectorAll('[data-ry-recommendation]');
    var started = false;
    if (!form || !result || !cards.length) return;

    form.addEventListener('change', function () {
      if (!started) { started = true; emit('training_finder_start', { page_path: window.location.pathname }); }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var formatField = form.querySelector('input[name="learning_format"]:checked');
      var goalField = form.querySelector('input[name="learning_goal"]:checked');
      var format = formatField ? formatField.value : '';
      var goal = goalField ? goalField.value : '';
      var missing = form.querySelector('[data-ry-finder-error]');
      if (!format || !goal) {
        if (missing) { missing.hidden = false; missing.focus(); }
        return;
      }

      var key = 'level-1';
      if (goal === 'specialist') key = 'specialist';
      else if (format === 'in-person') key = 'in-person';
      else if (goal === 'complete') key = 'full-journey';
      else if (goal === 'compare') key = 'compare';

      for (var i = 0; i < cards.length; i += 1) cards[i].hidden = cards[i].getAttribute('data-ry-recommendation') !== key;
      if (missing) missing.hidden = true;
      result.hidden = false;
      result.setAttribute('tabindex', '-1');
      result.focus();
      emit('training_finder_complete', { learning_format: format, learning_goal: goal, recommendation: key, page_path: window.location.pathname });
    });

    var links = root.querySelectorAll('[data-ry-recommendation-link]');
    for (var j = 0; j < links.length; j += 1) links[j].addEventListener('click', function () { emit('training_finder_recommendation_click', { recommendation: this.getAttribute('data-recommendation-key') || '', destination: this.getAttribute('href') || '' }); });
  }

  function initContact(root) {
    if (!root || root.dataset.ryContactInitialised === 'true') return;
    root.dataset.ryContactInitialised = 'true';
    var trainingSelect = root.querySelector('[data-ry-training-select]');
    var supportCheck = root.querySelector('[data-ry-payment-support]');
    var params = new URLSearchParams(window.location.search);
    var requested = params.get('training');
    if (requested === 'bangkok-october-2026') requested = 'bangkok-november-2026';
    if (trainingSelect && requested) for (var i = 0; i < trainingSelect.options.length; i += 1) if (trainingSelect.options[i].value === requested) { trainingSelect.selectedIndex = i; break; }
    if (supportCheck && (params.get('support') === 'payment' || params.get('topic') === 'payment-support')) supportCheck.checked = true;
    if (root.querySelector('[data-ry-lead-success]')) emit('lead_submit', { form_type: 'human_help', page_path: window.location.pathname });
  }

  function initAll(scope) {
    var context = scope || document;
    var finders = context.querySelectorAll('[data-ry-finder]');
    for (var i = 0; i < finders.length; i += 1) initFinder(finders[i]);
    var contacts = context.querySelectorAll('[data-ry-contact-root], .ry-contact-page');
    for (var j = 0; j < contacts.length; j += 1) initContact(contacts[j]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
